import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=05874824&scoped=true&"
import script from "./SchoolCard.vue?vue&type=script&lang=js&"
export * from "./SchoolCard.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCard.vue?vue&type=style&index=0&id=05874824&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05874824",
  null
  
)

export default component.exports